<script setup>
import { useReportMetrics } from 'dashboard/composables/useReportMetrics';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { STATUS } from 'dashboard/store/constants';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';
import { defineEmits } from 'vue';

const props = defineProps({
  metric: {
    type: Object,
    default: () => ({}),
  },
  accountSummaryKey: {
    type: String,
    default: 'getAccountSummary',
  },
  summaryFetchingKey: {
    type: String,
    default: 'getAccountSummaryFetchingStatus',
  },
});

defineEmits(['scrollToChart']);
const { t } = useI18n();
const { displayMetric, fetchingStatus } = useReportMetrics(
  props.accountSummaryKey,
  props.summaryFetchingKey
);
</script>

<template>
  <div class="text-n-slate-11 px-4">
    <div class="flex items-end text-n-slate-12">
      <div v-if="fetchingStatus === STATUS.FETCHING">
        <Spinner />
      </div>
      <div
        v-else-if="fetchingStatus === STATUS.FAILED"
        class="text-n-ruby-10 text-sm"
      >
        {{ t('REPORT.SUMMARY_FETCHING_FAILED') }}
      </div>
      <div
        v-else-if="fetchingStatus === STATUS.FINISHED"
        class="text-3xl font-bold"
      >
        {{ displayMetric(metric.KEY) }}
      </div>
    </div>
    <div class="flex justify-between">
      <span class="text-sm">
        {{ metric.NAME }}
      </span>
      <Icon
        icon="i-lucide-circle-arrow-down"
        class="size-4 text-n-brand hover:cursor-pointer"
        @click="$emit('scrollToChart', metric.KEY)"
      />
    </div>
  </div>
</template>
